/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Install_Ios_StepsInputs */

const th_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แตะปุ่มแชร์ด้านล่างของ Safari แล้วเลือก “เพิ่มไปยังหน้าจอโฮม” ระบบ iOS ไม่อนุญาตให้แอปเปิดหน้านี้ให้คุณเอง`)
};

const en_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap the Share button at the bottom of Safari, then choose “Add to Home Screen”. iOS gives no way for an app to open this for you.`)
};

const ja_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Safari 下部の共有ボタンをタップし、「ホーム画面に追加」を選んでください。iOS ではアプリからこの操作を開く方法がありません。`)
};

const zh_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 Safari 中点按“分享”，然后选择“添加到主屏幕”。iOS 不允许任何应用替你打开它。`)
};

const es_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toca el botón Compartir en la parte inferior de Safari y elige «Añadir a pantalla de inicio». iOS no permite que una aplicación lo abra por ti.`)
};

const pt_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toque no botão Compartilhar na parte de baixo do Safari e escolha “Adicionar à Tela de Início”. O iOS não permite que um aplicativo abra isso para você.`)
};

const id_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ketuk Bagikan di Safari, lalu pilih Tambahkan ke Layar Utama. iOS tidak mengizinkan aplikasi mana pun membukanya untuk Anda.`)
};

const fr_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Touchez le bouton Partager en bas de Safari, puis choisissez « Sur l’écran d’accueil ». iOS ne permet pas à une application de l’ouvrir pour vous.`)
};

const tl_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pindutin ang Share sa Safari, pagkatapos ay Add to Home Screen. Hindi pinapayagan ng iOS ang alinmang app na buksan ito para sa iyo.`)
};

const vi_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chạm Chia sẻ trong Safari, rồi chọn Thêm vào màn hình chính. iOS không cho ứng dụng nào mở giúp bạn.`)
};

const ko_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Safari에서 공유를 누른 뒤 홈 화면에 추가를 선택하세요. iOS는 어떤 앱도 이를 대신 열도록 허용하지 않습니다.`)
};

const de_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tippe unten in Safari auf „Teilen“ und wähle „Zum Home-Bildschirm“. iOS erlaubt keiner App, das für dich zu öffnen.`)
};

const ru_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нажмите «Поделиться» в Safari, затем «На экран «Домой»». iOS не позволяет ни одному приложению открыть это за вас.`)
};

const tr_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Safari'de Paylaş'a dokunun, sonra Ana Ekrana Ekle'yi seçin. iOS hiçbir uygulamanın bunu sizin için açmasına izin vermez.`)
};

const it_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tocca Condividi in Safari, poi Aggiungi a Home. iOS non permette a nessuna app di farlo al posto tuo.`)
};

const pl_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dotknij Udostępnij w Safari, a potem Dodaj do ekranu początkowego. iOS nie pozwala żadnej aplikacji zrobić tego za ciebie.`)
};

const uk_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Натисніть «Поділитися» в Safari, потім «На екран «Домівка»». iOS не дозволяє жодному застосунку відкрити це за вас.`)
};

const hi_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Safari में शेयर दबाएँ, फिर होम स्क्रीन में जोड़ें चुनें। iOS किसी भी ऐप को यह आपके लिए खोलने नहीं देता।`)
};

const ar_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اضغط مشاركة في Safari، ثم اختر إضافة إلى الشاشة الرئيسية. لا يسمح iOS لأي تطبيق بفتحها نيابةً عنك.`)
};

const ms_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ketik Kongsi dalam Safari, kemudian pilih Tambah ke Skrin Utama. iOS tidak membenarkan mana-mana aplikasi membukanya untuk anda.`)
};

const bn_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Safari-তে শেয়ার চাপুন, তারপর হোম স্ক্রিনে যোগ করুন বেছে নিন। iOS কোনও অ্যাপকে আপনার হয়ে এটি খুলতে দেয় না।`)
};

const zh_tw2_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 Safari 中點一下「分享」，然後選擇「加入主畫面」。iOS 不允許任何應用程式代你開啟它。`)
};

const zh_hk2_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 Safari 中點一下「分享」，然後選擇「加入主畫面」。iOS 不允許任何應用程式代你開啟它。`)
};

const ur_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Safari میں شیئر دبائیں، پھر ہوم اسکرین میں شامل کریں چنیں۔ iOS کسی ایپ کو یہ آپ کے لیے کھولنے نہیں دیتا۔`)
};

const fa_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در Safari روی هم‌رسانی بزنید، سپس افزودن به صفحهٔ خانه را برگزینید. iOS به هیچ برنامه‌ای اجازه نمی‌دهد این کار را برایتان انجام دهد.`)
};

const sw_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gusa Shiriki kwenye Safari, kisha chagua Ongeza kwenye Skrini ya Mwanzo. iOS hairuhusu programu yoyote kuifungua kwa niaba yako.`)
};

const nl_install_ios_steps = /** @type {(inputs: Install_Ios_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tik op Deel in Safari en kies Zet op beginscherm. iOS staat geen enkele app toe dat voor je te doen.`)
};

/**
* | output |
* | --- |
* | "Tap the Share button at the bottom of Safari, then choose “Add to Home Screen”. iOS gives no way for an app to open this for you." |
*
* @param {Install_Ios_StepsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const install_ios_steps = /** @type {((inputs?: Install_Ios_StepsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Install_Ios_StepsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_install_ios_steps(inputs)
	if (locale === "ja") return ja_install_ios_steps(inputs)
	if (locale === "zh") return zh_install_ios_steps(inputs)
	if (locale === "es") return es_install_ios_steps(inputs)
	if (locale === "pt") return pt_install_ios_steps(inputs)
	if (locale === "id") return id_install_ios_steps(inputs)
	if (locale === "fr") return fr_install_ios_steps(inputs)
	if (locale === "tl") return tl_install_ios_steps(inputs)
	if (locale === "vi") return vi_install_ios_steps(inputs)
	if (locale === "ko") return ko_install_ios_steps(inputs)
	if (locale === "de") return de_install_ios_steps(inputs)
	if (locale === "ru") return ru_install_ios_steps(inputs)
	if (locale === "tr") return tr_install_ios_steps(inputs)
	if (locale === "it") return it_install_ios_steps(inputs)
	if (locale === "pl") return pl_install_ios_steps(inputs)
	if (locale === "uk") return uk_install_ios_steps(inputs)
	if (locale === "hi") return hi_install_ios_steps(inputs)
	if (locale === "ar") return ar_install_ios_steps(inputs)
	if (locale === "ms") return ms_install_ios_steps(inputs)
	if (locale === "bn") return bn_install_ios_steps(inputs)
	if (locale === "zh-TW") return zh_tw2_install_ios_steps(inputs)
	if (locale === "zh-HK") return zh_hk2_install_ios_steps(inputs)
	if (locale === "ur") return ur_install_ios_steps(inputs)
	if (locale === "fa") return fa_install_ios_steps(inputs)
	if (locale === "sw") return sw_install_ios_steps(inputs)
	if (locale === "nl") return nl_install_ios_steps(inputs)
	return en_install_ios_steps(inputs)
});